import React, { memo } from 'react';
import BlockMarkdown from './BlockMarkdown';
import { extractBlockItems } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function TimelineBlock({ block, renderContext }) {
    const items = extractBlockItems(block);
    if (!items.length) return null;

    return (
        <section className={styles.timelineBlock} aria-label={block.title || 'Timeline'}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <ol className={styles.timelineList}>
                {items.map((item, index) => {
                    const title = item.title || item.label;
                    const description = item.description || item.content || item.markdown;
                    const timestamp = item.timestamp || item.date || item.time;
                    if (!title && !description && !timestamp) return null;
                    return (
                        <li key={item.id || `timeline-${index}`} className={styles.timelineItem}>
                            {timestamp ? <time className={styles.timelineTimestamp}>{timestamp}</time> : null}
                            {title ? <div className={styles.timelineTitle}>{title}</div> : null}
                            {description ? (
                                <BlockMarkdown content={description} {...renderContext} />
                            ) : null}
                        </li>
                    );
                })}
            </ol>
        </section>
    );
}

export default memo(TimelineBlock);
